import styled from '@emotion/styled';
import { theme } from '@vfit/shared/themes';

const ContainerTopProduct = styled.div<{ haveTitle?: boolean }>`
  margin-top: ${({ haveTitle }) => (haveTitle ? '45px' : 0)};
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.regular};
`;

export default ContainerTopProduct;

